import { generateOrganizationId } from 'dashboard/lib/stubs/organization';
import { User, UserAttributes, UserRelationships, UserStatus } from 'dashboard/models/user';
import { ApiModel } from 'lib/interfaces/api';

export function createPreviewUser(
  attributes?: Partial<UserAttributes>,
  id?: string,
  relationships?: Partial<UserRelationships>,
): User {
  return {
    attributes: {
      'email-address': 'admin@acme.com',
      status: UserStatus.Active,
      'enabled-mfa-methods': [],
      'available-mfa-methods': [],
      'homepage-priority': ['inquiries', 'cases', 'verifications', 'reports'],
      ...attributes,
    },
    relationships: {
      organization: { data: { type: ApiModel.Organization, id: generateOrganizationId() } },
      roles: { data: [] },
      ...relationships,
    },
    id: id || 'user_123',
    type: ApiModel.User,
  };
}
